"use client";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "@/components/ui/carousel";

import { PersianNum } from "@/util/tools/PersianNum";
import Image from "next/image";
import Link from "next/link";
import FireIcon from "../category/components/FireIcon";
import { ProductEssenceType } from "../essence/type";

type Props = {
    data: ProductEssenceType;
    title: string;
};

const ProductCreatorList = ({ data, title }: Props) => {
    return (
        <div>
            <p className="font-bold sm:text-2xl text-base text-text p-2">{title}</p>
            <Carousel
                opts={{
                    align: "start",
                    loop: true,
                    direction: "rtl",
                }}
                className="w-full"
            >
                <CarouselContent className="-ml-2 md:-ml-4">
                    {data?.data?.rows?.map((item) => (
                        <CarouselItem
                            key={item.id}
                            className="pl-2 basis-1/2 lg:basis-1/3 xl:basis-1/6"
                        >
                            <Link
                                href={`/product/${item?.product_url.replace(/ /g, "-")}`}
                                className="relative h-auto w-full max-w-[180px] my-2 block text-center bg-main rounded-md shadow"
                            >
                                {item?.ProductIdentities[0]?.Warehouses[0]?.warehouse_discount ? (
                                    <div className="absolute top-1 left-1 z-40 border rounded-full shadow">
                                        <FireIcon />
                                    </div>
                                ) : null}

                                <div className="relative aspect-square w-full overflow-hidden">
                                    <Image
                                        fill
                                        alt={item?.product_image_alt || item.product_title}
                                        src={
                                            process.env.NEXT_PUBLIC_IMAGE_URL + item?.product_image || "/placeholder.png"
                                        }
                                        priority
                                        sizes="(max-width: 600px) 100vw, 180px"
                                        className="object-cover image-no-bg"
                                    />
                                </div>

                                <div className="w-full text-right">
                                    <div className="bg-pewter rounded-b-lg ">
                                        <div className="p-1">
                                            <p className="text-[13px] text-center font-semibold text-text truncate pt-1">
                                                {item?.product_title}
                                            </p>

                                        </div>

                                        <div className="flex p-1 justify-between">
                                            {item?.ProductIdentities[0]?.Warehouses[0]?.warehouse_count <= 0 ||
                                                item?.ProductIdentities[0]?.Warehouses[0]?.warehouse_available === false ? (
                                                <div className="h-10 w-2/3">
                                                    <div className="h-5"></div>
                                                    <p className="h-5 font-sm text-slate-600">نا موجود</p>
                                                </div>
                                            ) : (
                                                <div className="h-10 w-2/3">
                                                    <div className="h-5">
                                                        {item?.ProductIdentities[0]?.Warehouses[0]?.warehouse_discount ? (
                                                            <p className="text-sm font-bold text-salmon">
                                                                {PersianNum(item?.ProductIdentities[0]?.Warehouses[0]?.warehouse_discount)}
                                                                <span className="text-[12px] mr-1">تومان</span>
                                                            </p>
                                                        ) : null}
                                                    </div>
                                                    <div className="h-5">
                                                        {item?.ProductIdentities[0]?.Warehouses[0]?.warehouse_discount ? (
                                                            <p className="text-sm line-through text-slate-600">
                                                                {PersianNum(item?.ProductIdentities[0]?.Warehouses[0]?.warehouse_price)}
                                                                <span className="text-[12px] mr-1">تومان</span>
                                                            </p>
                                                        ) : (
                                                            <p className="text-sm ">
                                                                {PersianNum(item?.ProductIdentities[0]?.Warehouses[0]?.warehouse_price)}
                                                                <span className="text-[12px] mr-1">تومان</span>
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                            <div className="w-2/3">
                                                <div className="h-5">
                                                    {item?.ProductIdentities[0]?.Warehouses[0]?.warehouse_count > 0 &&
                                                        item?.ProductIdentities[0]?.Warehouses[0]?.warehouse_count < 3 &&
                                                        item?.ProductIdentities[0]?.Warehouses[0]?.warehouse_available && (
                                                            <p className="text-[12px] text-salmon text-left">
                                                                موجودی :
                                                                <span className="text-base font-bold mx-1">
                                                                    {PersianNum(item?.ProductIdentities[0]?.Warehouses[0]?.warehouse_count)}
                                                                </span>
                                                            </p>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </CarouselItem>
                    ))}
                </CarouselContent>
                <CarouselPrevious />
                <CarouselNext />
            </Carousel>
        </div>
    );
};

export default ProductCreatorList;
